import EcoPagination from 'eco-design/base/eco-pagination';
import EcoSpace from 'eco-design/base/eco-space';
import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import BlogTimer from 'lowcomp/plugins/blog/common/blog-timer';
import { getBlogTagFromList } from 'lowcomp/plugins/blog/common/utils';
import { useRouter } from 'next/router';
import BlogCategoryNav from '../category-nav';
import { Fragment } from 'react';
import './index.scss';
export default function BlogCategoryItems({ categoryId, categoryData = {}, categoryTagList = [] }: { categoryId: string | string[]; categoryData: any, categoryTagList?: any }) {
    const itemsA = categoryData?.items;
    const total = categoryData?.total;
    const pageIndex = Number(categoryId[2]) || 1;
    const categoryIdA = categoryId[0] || '';
    const { locale = 'us' } = useRouter();

    return (
        <>
            <div className="blog-category-list-page-container">
                {/* <EcoSpace /> */}
                {/* <BlogNav title={categoryData.categoryName} /> */}
                <BlogCategoryNav categoryData={categoryData} categoryTagList={categoryTagList} />
                <div className={`blog-category-list eco-content category-tag-content`}>
                    {itemsA.map((item: any, index: number) => {
                        const thePage = JSON.parse(item.thePage || '{}');
                        const tagItem = getBlogTagFromList(item.blogTagList || [], categoryIdA);
                        return (
                            <Fragment key={index}>
                                <EcoBlogCard
                                    label={tagItem.tag}
                                    title={thePage.blogTitle}
                                    pc={thePage.blogImgPc}
                                    h5={thePage.blogImgH5}
                                    href={item.seoUrl}
                                    categoryHref={`/${locale}/blog/category/${categoryIdA}`}
                                    timer={BlogTimer(item.newFirstReleaseTime || item.createTime, locale)}
                                />
                            </Fragment>
                        );
                    })}
                </div>
                <EcoPagination
                    total={total}
                    current={pageIndex}
                    isOpenLink={true}
                    defaultPageSize={18}
                    linkBefore={`/${locale}/blog/category/${categoryIdA}/page/`}
                    className="blog-category-list-page"
                />
                <EcoSpace />
            </div>
        </>
    );
}
